import React from "react";

class SERPFooterView extends React.Component {


    render() {
        return (
            <div className="card border-top-box w-100">
                <ul className="list-unstyled">
                    <li>
                        <a
                            className="btn btn-link pb-0 text-cuvered-pink"
                            href="https://cuvered.com/about/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            About Cuvered
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pt-0 pb-0 text-cuvered-pink"
                            href="https://cuvered.com/f-a-q/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            F.A.Q
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pt-0 pb-0 text-cuvered-pink"
                            href="https://cuvered.com/blog/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Blog
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pb-0 text-cuvered-dark-blue"
                            href="https://cuvered.com/terms-of-service/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Terms of Service
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pt-0 pb-0 text-cuvered-dark-blue"
                            href="https://cuvered.com/privacy-policy/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pb-0 text-cuvered-light-blue"
                            href="https://www.cuvered.com/contact/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Contact Us
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pt-0 pb-0 text-cuvered-light-blue"
                            href="https://www.cuvered.com/investors/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Investors
                        </a>
                    </li>
                    <li>
                        <a
                            className="btn btn-link pt-0 pb-0 text-cuvered-light-blue"
                            href="https://www.cuvered.com/careers/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Careers
                        </a>
                    </li>
                </ul>
                <div className="row justify-content-center ">
                    Follow Us:
                    <a
                        className="btn btn-link mr-0 p-1  pt-0 pb-0 text-cuvered-dark-blue"
                        href="https://www.facebook.com/TheRealCuvered"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fab fa-facebook-f" />
                    </a>
                    <a
                        className="btn btn-link mr-0 p-1 pt-0 pb-0 text-cuvered-dark-blue"
                        href="https://www.instagram.com/therealcuvered/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fab fa-instagram" />
                    </a>
                    <a
                        className="btn btn-link mr-0 p-1 pt-0 pb-0 text-cuvered-dark-blue"
                        href="https://twitter.com/CuveredOfficial"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fab fa-twitter" />
                    </a>
                    <a
                        className="btn btn-link mr-0 p-1 pt-0 pb-0 text-cuvered-dark-blue"
                        href="https://www.linkedin.com/company/cuvered/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fab fa-linkedin-in" />
                    </a>
                </div>
                <div className="row justify-content-center text-muted mb-2 lh-1">
                    <i className="far fa-copyright mr-1" />
                    2020 Cuvered Technology LLC
                </div>
            </div>
        );
    }


}

export default SERPFooterView;